import React from 'react';

import Bar from './Bar';
import { motion } from 'framer-motion'
import { tools, languages } from './data/resume_data'


const Resume = () => {

    const resume_variants = {
        hidden: {
            opacity: 0
        },
        visible: {
            opacity: 1,
            transition: {
                delay: 0.2, duration: 0.6,
            }
        },
        exit: {
            opacity: 0,
            transition: {
                ease: 'easeInOut'
            }
        }
    }
    return (
        <motion.div className="container resume"

            variants={resume_variants}
            initial="hidden"
            animate="visible"
            exit="exit"

        >
            <div className="row">
                <div className="col-lg-6 resume-card" >
                    <h4 className="resume-card__heading">
                        Education
                    </h4>
                    <div className="resume-card__body">
                        <h5 className="resume-card__title">
                            Grade 12 Student
                        </h5>
                        <p className="resume-card__name">
                            STI GENSAN, South Cotabato 9500
                        </p>
                        <p className="resume-card__details">Because of Covid19, i paused my schooling and focused more on honing my coding skills so i can earn even just a small amount of money</p>
                    </div>
                </div>

                <div className="col-lg-6 resume-card" >
                    <h4 className="resume-card__heading">
                        Experience
                    </h4>
                    <div className="resume-card__body">
                        <h5 className="resume-card__title">
                            CTO , Security Engineer,Senior Sofware Engineer
                        </h5>
                        <p className="resume-card__name">
                            Paytrixx,Boxtypped Technologies, UCC Corporations,8layers Technologies
                        </p>
                        <p className="resume-card__details">Develop project concepts and maintain optimal workflow. Senior developer to manage large, complex design projects for stable, Pentest And Make Security Audiot And Patch Vulnerabilities </p>
                    </div>
                </div>
            </div>

            
        



            <div className="row">
                <div className="col-lg-6 resume-languages">
                    <h5 className="reume-language__heading">
                        Language and Framework
                    </h5>
                    <div className="resume-language__body mt-3">
                        {
                            languages.map(language =>
                                <Bar value={language} />
                            )
                        }
                    </div>
                </div>
                <div className="col-lg-6 resume-languages">
                    <h5 className="reume-language__heading">
                        Tools and Softwares
                    </h5>
                    <div className="resume-language__body mt-3">
                        {
                            tools.map(tool => <Bar value={tool} />)
                        }
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default Resume;